import { capitalizationImages } from './common';
import { diceImages } from './dice-game';
import { ticketImages } from './lottery';
import { cashImages, tgemImages, usdImages } from './wallet';

export const imageMap = {
  tgem: tgemImages.icon,
  cash: cashImages.icon,
  dice: diceImages.icon,
  usd: usdImages.icon,
  silverTicket: ticketImages.silver,
  goldTicket: ticketImages.gold,
  diamondTicket: ticketImages.diamond,
  silverTicket3d: ticketImages.silver3d,
  goldTicket3d: ticketImages.gold3d,
  diamondTicket3d: ticketImages.diamond3d,
  capitalizationLg: capitalizationImages.iconLg,
} as const;
export type ImageKey = keyof typeof imageMap;
export const getImageFromMapObj = (
  key: string,
): { png: string; webp: string } =>
  imageMap[key as ImageKey] ?? { png: '', webp: '' };
